import request from './../../utilities/request';
import localStorageToken from './../../utilities/storage';

function get() {
  return request({
    url:    `/permission/list`,
    headers: {'Authorization': localStorageToken()},
    method: 'GET'
  });
}

const PermissionService = {
  get
}

export default PermissionService;
